import { useState, type ReactElement } from 'react';
import { Button } from '../../components/ui/button';
import { OmieEntradaReviewDialog } from '../compras/omie-entrada-review-dialog';

/** L-68 (17.1-27): quem aprova a proposta fiscal local (financeiro:aprovar-fiscal) revisa a da NF de remessa na conferência do recebimento. */
export function podeRevisarPropostaDoRecebimento(permissoes: readonly string[] | null, propostaFiscalId: string | null | undefined): boolean {
  return permissoes !== null && Boolean(propostaFiscalId) && permissoes.includes('financeiro:aprovar-fiscal');
}

export interface RevisarPropostaRecebimentoProps {
  readonly permissoes: readonly string[] | null;
  readonly propostaFiscalId: string | null | undefined;
}

/** Mesmo diálogo "Revisão da proposta de entrada" da conferência da NF de compra; nada é enviado à Omie. */
export function RevisarPropostaRecebimento({ permissoes, propostaFiscalId }: RevisarPropostaRecebimentoProps): ReactElement | null {
  const [aberto, setAberto] = useState(false);
  if (!permissoes || !propostaFiscalId || !podeRevisarPropostaDoRecebimento(permissoes, propostaFiscalId)) return null;
  return (
    <>
      <Button type="button" variant="outline" className="min-h-11" onClick={() => setAberto(true)}>Revisar proposta Omie</Button>
      <OmieEntradaReviewDialog aberto={aberto} onAbertoChange={setAberto} propostaFiscalId={propostaFiscalId} permissoes={permissoes} />
    </>
  );
}
